import { DEV } from "~frontend/consts";

// utility function that should be used only in this directory
// as it's not type safe
export function pushToDataLayer(data: any) {
  if (window && !DEV) {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    window.dataLayer.push(data);
  }
}
